module.exports = __webpack_public_path__ + "static/media/medical_system.ff847451.jpg";